'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nitroLoading = require('../nitro-loading');

var _nitroLoading2 = _interopRequireDefault(_nitroLoading);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroButton = function NitroButton(props) {
  var action = props.action,
      block = props.block,
      disabled = props.disabled,
      className = props.className,
      icon = props.icon,
      insideIconSize = props.insideIconSize,
      label = props.label,
      labelVariant = props.labelVariant,
      leftIcon = props.leftIcon,
      leftIconVariant = props.leftIconVariant,
      loading = props.loading,
      loadingSpinnerColor = props.loadingSpinnerColor,
      outlined = props.outlined,
      rightIcon = props.rightIcon,
      rightIconVariant = props.rightIconVariant,
      size = props.size,
      variant = props.variant;


  var handleClick = function handleClick(event) {
    if (action && !disabled) {
      event.preventDefault();
      return action(event);
    }

    return null;
  };

  var iconInside = leftIcon !== undefined || rightIcon !== undefined;

  var labelComponent = _react2.default.createElement(
    _styles.ButtonLabel,
    { componentName: 'Label', className: 'button-label', size: size },
    icon && _react2.default.createElement(_nitroIcon2.default, { name: icon, size: 14, right: 8 }),
    label
  );

  var left = iconInside && _react2.default.createElement(
    _styles.ButtonIcon,
    { insideIconSize: insideIconSize },
    leftIcon && _react2.default.createElement(_nitroIcon2.default, {
      name: leftIcon,
      variant: leftIconVariant || 'white',
      size: insideIconSize
    })
  );

  var right = iconInside && _react2.default.createElement(
    _styles.ButtonIcon,
    { insideIconSize: insideIconSize },
    rightIcon && _react2.default.createElement(_nitroIcon2.default, {
      name: rightIcon,
      variant: rightIconVariant || 'white',
      size: insideIconSize
    })
  );

  var classes = (0, _classnames2.default)('button', className);

  return _react2.default.createElement(
    _styles.Button,
    {
      className: classes,
      onClick: handleClick,
      block: block,
      disabled: disabled,
      variant: variant
    },
    _react2.default.createElement(
      _styles.ButtonContent,
      {
        className: 'button-content',
        variant: variant,
        labelVariant: labelVariant,
        outlined: outlined
      },
      loading && _react2.default.createElement(_nitroLoading2.default, {
        size: 22,
        thickness: 2,
        position: 'center',
        loadingButton: true,
        variant: variant,
        color: loadingSpinnerColor
      }),
      _react2.default.createElement(
        _styles.ButtonInner,
        {
          loading: loading
        },
        left,
        labelComponent,
        right
      )
    ),
    disabled && _react2.default.createElement(_styles.ButtonDisabledCover, null)
  );
};

NitroButton.propTypes = {
  action: _propTypes2.default.func,
  block: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  insideIconSize: _propTypes2.default.number,
  label: _propTypes2.default.string,
  labelVariant: _propTypes2.default.string,
  leftIcon: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  loadingSpinnerColor: _propTypes2.default.string,
  outlined: _propTypes2.default.bool,
  rightIcon: _propTypes2.default.string,
  size: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

NitroButton.defaultProps = {
  insideIconSize: 8,
  size: 'default'
};

exports.default = NitroButton;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button/NitroButton.js
// module id = 2889
// module chunks = 4